function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_2616",
  "data-name": "Group 2616",
  transform: "translate(-72.504 -905.086)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2602",
  "data-name": "Group 2602",
  transform: "translate(-150 294)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2600",
  "data-name": "Group 2600"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2598",
  "data-name": "Group 2598",
  transform: "translate(-73.723 419.483)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2596",
  "data-name": "Group 2596",
  transform: "translate(297.722 193.517)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3741",
  "data-name": "Path 3741",
  d: "M328.87,251.281a12.118,12.118,0,0,1-5.2,1.557,11.643,11.643,0,0,1-5.2-1.554l.908-1.208a2.836,2.836,0,0,1,1.421-1.032,2.478,2.478,0,0,1,.573-.1c1.141-.091,1.4.358,2.327.372s1.182-.442,2.324-.331a2.53,2.53,0,0,1,.712.165,2.867,2.867,0,0,1,1.215.935Z",
  transform: "translate(-301.141 -202.65)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3742",
  "data-name": "Path 3742",
  d: "M327.018,240.986c-.079.34-.334.414-1.327,1.1a3.635,3.635,0,0,1-3.726,0c-.992-.69-1.247-.764-1.326-1.1",
  transform: "translate(-301.499 -201.341)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  id: "Group_2594",
  "data-name": "Group 2594",
  transform: "translate(5.409 27.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3743",
  "data-name": "Path 3743",
  d: "M304.2,226.438a2.528,2.528,0,0,1,3.113.017,6.054,6.054,0,0,0,2.592,1.325,6.321,6.321,0,0,0,2.04.108,14.942,14.942,0,0,0,2.686-.645c.634-.178,1.166-.33,1.553-.442",
  transform: "translate(-304.198 -225.91)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3744",
  "data-name": "Path 3744",
  d: "M308.1,229.256a2.426,2.426,0,0,1,1.908-1.289",
  transform: "translate(-304.842 -226.249)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_2595",
  "data-name": "Group 2595",
  transform: "translate(27.125 27.054)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3745",
  "data-name": "Path 3745",
  d: "M340.691,225.911a2.569,2.569,0,0,0-1.619.544,6.059,6.059,0,0,1-2.592,1.325,6.327,6.327,0,0,1-2.041.108,14.959,14.959,0,0,1-2.686-.645c-.633-.178-1.165-.33-1.553-.442",
  transform: "translate(-330.201 -225.91)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("path", {
  id: "Path_3746",
  "data-name": "Path 3746",
  d: "M297.765,222.728c0-5.249-.1-6,0-11.642.567-1.638,7.043-5.57,12.385-9.6a31.12,31.12,0,0,1,6.412-3.717",
  transform: "translate(-297.722 -194.218)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3747",
  "data-name": "Path 3747",
  d: "M346.019,225.394c0-5.093.167-9.735,0-15.077-.3-.713-13.929-12.98-24.745-16.8",
  transform: "translate(-301.604 -193.517)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3748",
  "data-name": "Path 3748",
  d: "M316.462,219.1A6.6,6.6,0,0,0,312.514,217a21.638,21.638,0,0,0-6.185,0",
  transform: "translate(-299.141 -197.349)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3749",
  "data-name": "Path 3749",
  d: "M328.547,219.069a6.6,6.6,0,0,1,3.948-2.105,21.605,21.605,0,0,1,6.185,0",
  transform: "translate(-302.803 -197.343)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_3750",
  "data-name": "Path 3750",
  d: "M330.1,256.935c-3.292,2.952-6.855,4.645-10.131,4.645-7.841,0-22.2-15.189-22.2-33.926",
  transform: "translate(-297.731 -199.144)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 3
})), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_182",
  "data-name": "Ellipse 182",
  cx: 17.088,
  cy: 17.088,
  r: 17.088,
  transform: "translate(330.548 231.074)",
  strokeWidth: 3,
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_2599",
  "data-name": "Group 2599",
  transform: "translate(228.889 665.562)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_2565",
  "data-name": "Group 2565",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3640",
  "data-name": "Path 3640",
  d: "M96.415,99.586s.885,9.615-.4,12.489a13.2,13.2,0,0,1-3.612,4.811",
  transform: "translate(-92.703 -98.909)",
  fill: "none",
  stroke: "#a64daa",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 3
})))), /*#__PURE__*/React.createElement("g", {
  id: "Path_3756",
  "data-name": "Path 3756",
  transform: "translate(122 960)",
  fill: "#a64daa"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0.3828159272670746 17.95214462280273 C -1.007634043693542 17.95214462280273 -4.411563873291016 16.13161468505859 -7.535014152526855 13.71744537353516 C -11.03598403930664 11.01147556304932 -13.21082401275635 8.348225593566895 -13.21082401275635 6.76700496673584 C -13.21082401275635 6.207255363464355 -12.93626403808594 5.801295280456543 -12.34675407409668 5.489425182342529 C -11.59591388702393 5.0921950340271 -10.39429378509521 4.890795230865479 -8.775263786315918 4.890795230865479 C -8.232724189758301 4.890795230865479 -7.636363983154297 4.913955211639404 -7.002754211425781 4.95964527130127 C -6.287904262542725 5.011185169219971 -5.595354080200195 5.037344932556152 -4.944354057312012 5.037405014038086 C -4.943830966949463 5.037405014038086 -4.942710399627686 5.037405014038086 -4.942187309265137 5.037405014038086 C -0.6583952903747559 5.037405014038086 2.211633920669556 3.940519571304321 3.833116054534912 1.683765172958374 C 5.214295864105225 -0.238544836640358 5.395825862884521 -2.624234914779663 5.541696071624756 -4.541164875030518 C 5.716365814208984 -6.836694717407227 5.870835781097412 -7.704104900360107 6.808596134185791 -7.704104900360107 C 7.105735778808594 -7.704104900360107 7.412166118621826 -7.708504676818848 7.73659610748291 -7.713154792785645 C 8.078226089477539 -7.718064785003662 8.431486129760742 -7.723134994506836 8.791866302490234 -7.723134994506836 C 11.29597568511963 -7.723134994506836 13.85939598083496 -7.467324733734131 15.64525604248047 -5.611604690551758 C 16.42585563659668 -4.800474643707275 17.01431655883789 -3.711914777755737 17.39429664611816 -2.37616491317749 C 17.83021545410156 -0.8437648415565491 18.00784683227539 1.064055204391479 17.92224502563477 3.294295072555542 C 17.81449508666992 6.101775169372559 17.03615570068359 8.586145401000977 15.60885620117188 10.67838478088379 C 14.40249633789062 12.44675540924072 12.72789573669434 13.94879531860352 10.63156604766846 15.1428050994873 C 6.737986087799072 17.36045455932617 2.357395887374878 17.95214462280273 0.3828159272670746 17.95214462280273 Z",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M 8.791886329650879 -7.223134994506836 L 8.791895866394043 -7.223134994506836 C 8.435256004333496 -7.223125457763672 8.083966255187988 -7.218084335327148 7.744245529174805 -7.213214874267578 C 7.417805671691895 -7.208524703979492 7.109465599060059 -7.204105377197266 6.808595657348633 -7.204105377197266 C 6.613235473632812 -7.204105377197266 6.505616188049316 -7.204105377197266 6.365805625915527 -6.818304061889648 C 6.17668628692627 -6.296395301818848 6.110405921936035 -5.425515174865723 6.04024600982666 -4.503504753112793 C 5.75446605682373 -0.7480649948120117 5.276165962219238 5.537405014038086 -4.9443039894104 5.537405014038086 C -5.606493949890137 5.537405014038086 -6.311153888702393 5.510805130004883 -7.038713932037354 5.458345413208008 C -7.660344123840332 5.413525104522705 -8.244604110717773 5.390795230865479 -8.775263786315918 5.390795230865479 C -10.68932342529297 5.390795230865479 -11.64678382873535 5.684775352478027 -12.11294364929199 5.931385040283203 C -12.63839340209961 6.209375381469727 -12.71082401275635 6.497284889221191 -12.71082401275635 6.76700496673584 C -12.71082401275635 7.160425186157227 -12.51242446899414 8.057024955749512 -11.1837043762207 9.641715049743652 C -10.21164417266846 10.80103492736816 -8.844213485717773 12.07359504699707 -7.229244232177734 13.32183456420898 C -3.884294033050537 15.9072151184082 -0.7321739196777344 17.45214462280273 0.3828158378601074 17.45214462280273 C 2.308216094970703 17.45214462280273 6.581345558166504 16.8742561340332 10.38410568237305 14.70833492279053 C 12.41378593444824 13.55228519439697 14.03267669677734 12.1016149520874 15.1958065032959 10.39661502838135 C 16.56931686401367 8.383225440979004 17.31851577758789 5.987215042114258 17.42261505126953 3.275125026702881 C 17.57736587524414 -0.7569551467895508 16.85814666748047 -3.630265235900879 15.28492546081543 -5.264985084533691 C 13.62867546081543 -6.985994338989258 11.1854362487793 -7.223184585571289 8.791886329650879 -7.223134994506836 M 8.791867256164551 -8.22313117980957 C 13.18838882446289 -8.223222732543945 18.83612823486328 -7.479801177978516 18.421875 3.313475131988525 C 17.94140625 15.83203506469727 4.801085472106934 18.45214462280273 0.3828158378601074 18.45214462280273 C -3.864492893218994 18.45214462280273 -22.43255424499512 4.390790939331055 -8.775267601013184 4.390790939331055 C -8.225507736206055 4.390790939331055 -7.624026298522949 4.413547515869141 -6.966794013977051 4.460935115814209 C -6.250473022460938 4.512583255767822 -5.575821876525879 4.537402153015137 -4.944307327270508 4.537402153015137 C 9.397747039794922 4.537402153015137 2.576658248901367 -8.204105377197266 6.808595657348633 -8.204105377197266 C 7.417510032653809 -8.204105377197266 8.089096069335938 -8.223117828369141 8.791867256164551 -8.22313117980957 Z",
  stroke: "none",
  fill: "#a64daa"
})));

var SvgRednessIcon = function SvgRednessIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69.996,
    height: 75.146,
    viewBox: "0 0 69.996 75.146",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRednessIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/redness-icon.7401f15e.svg";
export { ForwardRef as ReactComponent };